import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";




function TeachingMethod() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
             <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Teaching and Learning Methodology <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="#1D4D93"/>
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>Teaching and Learning Methodology</b></h1>
                            <div className="col-md-8">
                            <hr style={{color:"#1D4D93"}}/>
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-12 mt-3">
                                        <div className='mission'>
                                        <p className='justify mb-2'>Our unique curriculum is lined up to the current understanding of teaching-learning. It facilitates consistent progress from the adolescence years through schooling to advance education, while ensuring a smooth transition from one level to the other. </p>
                                         <p className='justify mb-2'>The curriculum encourages students to be active learners who explore, understand participates in the world around them. By being exposed to a wide variety of disciplines both cognitive and non-cognitive. Students are well prepared for a well-balanced life life outside the school. </p>
                                          <p className='justify mb-2'>The integrated method is holistic, child-centered with no categorization of subjects. It seeks to give a complete experience to the children with the range of experiences and understanding. This approach goes a long way towards shaping a wholesome and healthy personality and gets children prepared for the primary school. </p>
                                        </div>
                                    </div>
                                    




                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default TeachingMethod